(function ($, Drupal) {
    Drupal.behaviors.filterajax = {
        attach: function (context, settings) {
            setAllCheckboxLabel();
            if (jQuery('.clearfilter').length > 0) {
                jQuery('.clearfilter').on('click', function () {
                    jQuery(this).closest('.fieldset').find('input').prop('checked', '');
                    jQuery(this).closest('.filter-wrapper').find('.form-submit').trigger('click');
                    jQuery(this).prev('.fieldset-legend').text('All');
                    jQuery(this).remove();
                });
            }
            if (jQuery('.search_option').length > 0) {
                jQuery('.search_option input').on('keyup', function () {
                    if (jQuery('.search_option input').val().trim() != '') {
                        jQuery('.search_option span.close-icon').show();
                        jQuery('.search_option span.search-icon').hide();
                    } else {
                        jQuery('.search_option span.close-icon').hide();
                        jQuery('.search_option span.search-icon').show();
                    }
                });
                jQuery('.search_option span.close-icon').on('click', function () {
                    jQuery('.search_option input').val('');
                    jQuery('.search_option span.close-icon').hide();
                    jQuery('.search_option span.search-icon').show();
                    jQuery(this).closest('.filter-wrapper').find('.form-submit').trigger('click');
                });

                jQuery('.search_option input').on('blur', function () {
                    if (jQuery('.search_option input').val().trim() != '') {
                        jQuery('.search_option span.close-icon').show();
                        jQuery('.search_option span.search-icon').hide();
                    } else {
                        jQuery('.search_option span.close-icon').hide();
                        jQuery('.search_option span.search-icon').show();
                    }
                });
            }

            jQuery('fieldset .parent').closest('.form-item').addClass('parent-item');
            jQuery('fieldset .child').closest('.form-item').addClass('child-item');
            jQuery('fieldset .sub-child').closest('.form-item').addClass('sub-child-item');
            jQuery('fieldset .sub-child-1').closest('.form-item').addClass('sub-child-1-item');


            jQuery(".parent-item").each(function () {
                jQuery(this).nextUntil(".parent-item").addBack().wrapAll('<div class="checkbox-item parent-checkbox-item"></div>');
            });
            jQuery(".child-item").each(function () {
                jQuery(this).nextUntil(".child-item").addBack().wrapAll('<div class="checkbox-item child-checkbox-item"></div>');
            });
            jQuery(".sub-child-item").each(function () {
                jQuery(this).nextUntil(".sub-child-item").addBack().wrapAll('<div class="checkbox-item subchild-checkbox-item"></div>');
            });
            jQuery(".sub-child-1-item").each(function () {
                jQuery(this).nextUntil(".sub-child-1-item").addBack().wrapAll('<div class="checkbox-item subchild-1-checkbox-item"></div>');
            });

            //wrap all parent and child item in separate div end

            // jQuery('html,body').on('click','.fieldset .fieldset-title', function (event) {
            //     if(window.matchMedia('(min-width:1025px)').matches){
            //         jQuery(".listing_page__wrapper .exposed-form .views-exposed-form .fieldset .form-checkboxes:not(.fieldgroup)").niceScroll('.fieldgroup',{
            //             cursoropacitymin:0.2,
            //             cursorcolor:'#0f3557',
            //             cursorborder:'none',
            //             cursorborderradius:4,
            //             cursoropacitymax: 0.3,
            //             horizrailenabled:false,
            //             cursorwidth:8,
            //             scrollspeed: 30,
            //             mousescrollstep: 20, 
            //         }).resize();
            //     }
            // });


            //custom multiselect nested checkbox js
            setTimeout(function () {
                if (!jQuery('body').hasClass('tempperclass')) {
                    jQuery('.parent-checkbox-item > .form-item input').on('change', function () {
                        jQuery(this).closest('.parent-checkbox-item').find('.checkbox-item input[type="checkbox"]').prop('checked', this.checked);
                    });

                    jQuery('.child-checkbox-item > .form-item input').on('change', function () {
                        jQuery(this).closest('.child-checkbox-item').find('.checkbox-item input[type="checkbox"]').prop('checked', this.checked);
                    });

                    jQuery('.subchild-checkbox-item > .form-item input').on('change', function () {
                        jQuery(this).closest('.subchild-checkbox-item').find('.checkbox-item input[type="checkbox"]').prop('checked', this.checked);
                    });
                    jQuery('.subchild-1-checkbox-item > .form-item input').on('change', function () {
                        jQuery(this).closest('.subchild-1-checkbox-item').find('.checkbox-item input[type="checkbox"]').prop('checked', this.checked);
                    });

                    jQuery('.child-checkbox-item .form-item input').on('change', function () {
                        var $parent = jQuery(this).closest('.parent-checkbox-item');
                        var totalcheckbox = jQuery(this).closest('.parent-checkbox-item').find('input:not(.parent)').length;
                        var chechedchekbox = jQuery(this).closest('.parent-checkbox-item').find('input:checked:not(.parent)').length;
                        var notcheckedbox = totalcheckbox - chechedchekbox;
                        if (notcheckedbox == 0) {
                            jQuery(this).closest('.parent-checkbox-item').find('> .form-item input').prop('checked', 'checked');
                        } else {
                            jQuery(this).closest('.parent-checkbox-item').find('> .form-item input').prop('checked', '');
                        }
                    });

                    jQuery('.subchild-checkbox-item .form-item input').on('change', function () {
                        var $parent = jQuery(this).closest('.parent-checkbox-item');
                        var totalparentcheckbox = jQuery(this).closest('.parent-checkbox-item').find('input:not(.parent)').length;
                        var chechedparentchekbox = jQuery(this).closest('.parent-checkbox-item').find('input:checked:not(.parent)').length;
                        var notcheckeparentdbox = totalparentcheckbox - chechedparentchekbox;
                        if (notcheckeparentdbox == 0) {
                            jQuery(this).closest('.parent-checkbox-item').find('> .form-item input').prop('checked', 'checked');
                        } else {
                            jQuery(this).closest('.parent-checkbox-item').find('> .form-item input').prop('checked', '');
                        }

                        var $childparent = jQuery(this).closest('.child-checkbox-item');
                        var totalsubcheckbox = jQuery(this).closest('.child-checkbox-item').find('input:not(.child)').length;
                        var chechedsubchekbox = jQuery(this).closest('.child-checkbox-item').find('input:checked:not(.child)').length;
                        var notcheckedcubbox = totalsubcheckbox - chechedsubchekbox;
                        if (notcheckedcubbox == 0) {
                            jQuery(this).closest('.child-checkbox-item').find('> .form-item input').prop('checked', 'checked');
                        } else {
                            jQuery(this).closest('.child-checkbox-item').find('> .form-item input').prop('checked', '');
                        }
                    });


                    jQuery('.subchild-1-checkbox-item .form-item input').on('change', function () {
                        var $parent = jQuery(this).closest('.parent-checkbox-item');
                        var totalparentcheckbox = jQuery(this).closest('.parent-checkbox-item').find('input:not(.parent)').length;
                        var chechedparentchekbox = jQuery(this).closest('.parent-checkbox-item').find('input:checked:not(.parent)').length;
                        var notcheckeparentdbox = totalparentcheckbox - chechedparentchekbox;
                        if (notcheckeparentdbox == 0) {
                            jQuery(this).closest('.parent-checkbox-item').find('> .form-item input').prop('checked', 'checked');
                        } else {
                            jQuery(this).closest('.parent-checkbox-item').find('> .form-item input').prop('checked', '');
                        }


                        var $childparent = jQuery(this).closest('.child-checkbox-item');
                        var totalchildcheckbox = jQuery(this).closest('.child-checkbox-item').find('input:not(.child)').length;
                        var chechedchildchekbox = jQuery(this).closest('.child-checkbox-item').find('input:checked:not(.child)').length;
                        var notcheckechilddbox = totalchildcheckbox - chechedchildchekbox;
                        if (notcheckechilddbox == 0) {
                            jQuery(this).closest('.child-checkbox-item').find('> .form-item input').prop('checked', 'checked');
                        } else {
                            jQuery(this).closest('.child-checkbox-item').find('> .form-item input').prop('checked', '');
                        }

                        var $subchildparent = jQuery(this).closest('.subchild-checkbox-item');
                        var totalsubcheckbox = jQuery(this).closest('.subchild-checkbox-item').find('input:not(.sub-child)').length;
                        var chechedsubchekbox = jQuery(this).closest('.subchild-checkbox-item').find('input:checked:not(.sub-child)').length;
                        var notcheckesubdbox = totalsubcheckbox - chechedsubchekbox;
                        if (notcheckesubdbox == 0) {
                            $subchildparent.find('> .form-item input').prop('checked', 'checked');
                        } else {
                            $subchildparent.find('> .form-item input').prop('checked', '');
                        }
                    });

                }

            }, 1000);
            //custom multiselect nested checkbox js end

            /*nice scroll for filter dropdown */
            //    if(window.matchMedia('(min-width:1025px)').matches){
            //     jQuery(".listing_page__wrapper .exposed-form .views-exposed-form .fieldset .form-checkboxes:not(.fieldgroup)").niceScroll('.fieldgroup',{
            //         cursoropacitymin:0.2,
            //         cursorcolor:'#0f3557',
            //         cursorborder:'none',
            //         cursorborderradius:4,
            //         cursoropacitymax: 0.3,
            //         horizrailenabled:false,
            //         cursorwidth:8,
            //         scrollspeed: 30,
            //         mousescrollstep: 20, 
            //     }).resize();
            // }

            if (jQuery('.mob-filter-btn').length > 0) {
                jQuery('.mob-filter-btn a').on('click', function () {
                    jQuery('.filter-wrapper').toggle();
                });
            }

            jQuery('body').click(function (event) {
                if (!jQuery(event.target).closest('.fieldset').length) {
                    jQuery('.fieldset .fieldset-wrapper').hide();
                    jQuery('.fieldset').removeClass('open');
                }
            });


            // collapsable filter option js changes
            jQuery('.child').each(function () {
                if (jQuery(this).closest('.child-checkbox-item').find('.subchild-checkbox-item').length > 0) {
                    var collapsetag = '<span class="collapse-child">collapse</span>';
                    jQuery(this).parent('.checkbox').prepend(collapsetag);
                }
            });

            jQuery('.sub-child').each(function () {
                if (jQuery(this).closest('.subchild-checkbox-item').find('.subchild-1-checkbox-item').length > 0) {
                    var collapsetag = '<span class="collapse-sub-child">collapse</span>';
                    jQuery(this).parent('.checkbox').prepend(collapsetag);
                    jQuery(".subchild-1-checkbox-item").hide();
                }
            });

            if (jQuery('.child-checkbox-item .form-item input:checked').length > 0) {
                jQuery('.child-checkbox-item .form-item input:checked').closest('.child-checkbox-item').find('.subchild-checkbox-item').show();
                // if(jQuery('.child-checkbox-item .form-item input:checked').hasClass('sub-child-1-item')){
                //     jQuery('.child-checkbox-item .form-item input:checked').closest('.subchild-checkbox-item').find('.subchild-1-checkbox-item').show();
                // }
            }

            //collapsable filter option js changes end


            //analitycs tag adding in all listing items
            jQuery('.signpost-listing__item').each(function () {
                if (jQuery(this).find('.signpost-listing__tag').length) {
                    var tag = jQuery(this).find('.signpost-listing__tag').text();
                    tag = tag.trim().replace(/\s+/g, '-').toLowerCase();
                    jQuery(this).find('a').addClass('analytics-tag-' + tag);
                }
            });
            jQuery('.news-list-wrapper').each(function () {
                if (jQuery(this).find('.news-list-title').length) {
                    var tag = jQuery(this).find('.news-list-title').text();
                    tag = tag.trim().replace(/\s+/g, '-').toLowerCase();
                    jQuery(this).find('a').addClass('analytics-tag-' + tag);
                }
            });

            jQuery('.signpost-listing__item').each(function () {
                if (jQuery(this).find('.signpost-listing__startdate').length) {
                    var tag = jQuery(this).find('.signpost-listing__startdate').text();
                    tag = tag.trim().replace(/\s+/g, '-').toLowerCase();
                    jQuery(this).find('a').addClass('analytics-tag-' + tag);
                }
            });

            //analitycs tag adding in all listing items end

        }
    };
})(jQuery, Drupal);

jQuery(document).ready(function () {
    // Trim Tag text and add full text title
    jQuery(".signpost-listing__tag, .newslist .news-list-wrapper .news-list-title, .news-video-container .video-content .vdo-title").each(function () {
        var trunc = jQuery(this).text();
        jQuery(this).attr('title', trunc);

        var truncatetext = jQuery(this).text();
        if (truncatetext.length > 50) {
            var tructtext = jQuery.trim(truncatetext).substring(0, 50) + "...";
            jQuery(this).text(tructtext);
        }
    });
});

//custom multiselect nested checkbox js on ajax complete 
// jQuery(document).once('weberAjaxViews').ajaxComplete(function(event, xhr, settings) {
//     jQuery(document).on("click", ".bam-lib .pagination .pagination__item a", function() {
//         setTimeout(function() {
//             var bamoffset = jQuery('.bam-lib').offset().top;
//             jQuery("html, body").animate({
//                 scrollTop: bamoffset
//             }, 500);
//         }, 2000);
//     });
// });
jQuery(document).ajaxSuccess(function () {

    jQuery(document).on('click', '.fieldset .fieldset-title', function (event) {
        event.stopPropagation();
        if (jQuery(this).parent('.fieldset').hasClass('open')) {
            jQuery(this).parent('.fieldset').removeClass('open');
            jQuery(this).next('div').hide();
        } else {
            jQuery('.fieldset .fieldset-wrapper').hide();
            jQuery('.fieldset').removeClass('open');
            jQuery(this).parent('.fieldset').addClass('open');
            jQuery(this).next('div').show();
        }
    });
    if (jQuery('.search_option').length > 0) {
        jQuery('.search_option input').on('keyup', function () {
            if (jQuery('.search_option input').val().trim() != '') {
                jQuery('.search_option span.close-icon').show();
                jQuery('.search_option span.search-icon').hide();
            } else {
                jQuery('.search_option span.close-icon').hide();
                jQuery('.search_option span.search-icon').show();
            }
        });
        jQuery('.search_option span.close-icon').on('click', function () {
            jQuery('.search_option input').val('');
            jQuery('.search_option span.close-icon').hide();
            jQuery('.search_option span.search-icon').show();
            setTimeout(function () {
                jQuery(this).closest('.filter-wrapper').find('.form-submit').trigger('click');
            }, 100);
        });

        jQuery('.search_option input').on('blur', function () {
            if (jQuery('.search_option input').val().trim() != '') {
                jQuery('.search_option span.close-icon').show();
                jQuery('.search_option span.search-icon').hide();
            } else {
                jQuery('.search_option span.close-icon').hide();
                jQuery('.search_option span.search-icon').show();
            }
        });
    }
});

jQuery(document).ajaxComplete(function () {

    // Trim Tag text and add full text title
    jQuery(".signpost-listing__tag, .newslist .news-list-wrapper .news-list-title, .news-video-container .video-content .vdo-title").each(function () {
        var truncatetext = jQuery(this).text();
        if (truncatetext.length > 50) {
            var tructtext = jQuery.trim(truncatetext).substring(0, 50) + "...";
            jQuery(this).text(tructtext);
        }
    });

    if (jQuery('.search_option').length > 0) {
        if (jQuery('.search_option input').val().trim() != '') {
            jQuery('.search_option span.close-icon').show();
            jQuery('.search_option span.search-icon').hide();
        } else {
            jQuery('.search_option span.close-icon').hide();
            jQuery('.search_option span.search-icon').show();
        }
    }

    jQuery(document).on('click', '.fieldset .fieldset-title', function (event) {
        event.stopPropagation();
        if (jQuery(this).parent('.fieldset').hasClass('open')) {
            jQuery(this).parent('.fieldset').removeClass('open');
            jQuery(this).next('div').hide();
        } else {
            jQuery('.fieldset .fieldset-wrapper').hide();
            jQuery('.fieldset').removeClass('open');
            jQuery(this).parent('.fieldset').addClass('open');
            jQuery(this).next('div').show();
        }
        // if(window.matchMedia('(min-width:1025px)').matches){
        //     jQuery(".listing_page__wrapper .exposed-form .views-exposed-form .fieldset .form-checkboxes:not(.fieldgroup)").niceScroll('.fieldgroup',{
        //         cursoropacitymin:0.2,
        //         cursorcolor:'#0f3557',
        //         cursorborder:'none',
        //         cursorborderradius:4,
        //         cursoropacitymax: 0.3,
        //         horizrailenabled:false,
        //         cursorwidth:8,
        //         scrollspeed: 30,
        //         mousescrollstep: 20, 
        //     }).resize();
        // }

        // if(window.matchMedia('(min-width:1025px)').matches){
        //     jQuery(".bam-filter-form .fieldset .fieldset-wrapper [class^=col]").niceScroll('.form-checkboxes',{
        //         cursoropacitymin:0.2,
        //         cursorcolor:'#0f3557',
        //         cursorborder:'none',
        //         cursorborderradius:4,
        //         cursoropacitymax: 0.3,
        //         horizrailenabled:false,
        //         cursorwidth:8,
        //         scrollspeed: 30,
        //         mousescrollstep: 20, 
        //     }).resize();
        // }

    });
    jQuery('.parent-checkbox-item > .form-item input').on('change', function () {
        jQuery(this).closest('.parent-checkbox-item').find('.checkbox-item input[type="checkbox"]').prop('checked', this.checked);
    });

    jQuery('.child-checkbox-item > .form-item input').on('change', function () {
        jQuery(this).closest('.child-checkbox-item').find('.checkbox-item input[type="checkbox"]').prop('checked', this.checked);
    });

    jQuery('.subchild-checkbox-item > .form-item input').on('change', function () {
        jQuery(this).closest('.subchild-checkbox-item').find('.checkbox-item input[type="checkbox"]').prop('checked', this.checked);
    });
    jQuery('.subchild-1-checkbox-item > .form-item input').on('change', function () {
        jQuery(this).closest('.subchild-1-checkbox-item').find('.checkbox-item input[type="checkbox"]').prop('checked', this.checked);
    });

    jQuery('.child-checkbox-item .form-item input').on('change', function () {
        var $parent = jQuery(this).closest('.parent-checkbox-item');
        var totalcheckbox = jQuery(this).closest('.parent-checkbox-item').find('input:not(.parent)').length;
        var chechedchekbox = jQuery(this).closest('.parent-checkbox-item').find('input:checked:not(.parent)').length;
        var notcheckedbox = totalcheckbox - chechedchekbox;
        if (notcheckedbox == 0) {
            jQuery(this).closest('.parent-checkbox-item').find('> .form-item input').prop('checked', 'checked');
        } else {
            jQuery(this).closest('.parent-checkbox-item').find('> .form-item input').prop('checked', '');
        }
    });

    jQuery('.subchild-checkbox-item .form-item input').on('change', function () {
        var $parent = jQuery(this).closest('.parent-checkbox-item');
        var totalparentcheckbox = jQuery(this).closest('.parent-checkbox-item').find('input:not(.parent)').length;
        var chechedparentchekbox = jQuery(this).closest('.parent-checkbox-item').find('input:checked:not(.parent)').length;
        var notcheckeparentdbox = totalparentcheckbox - chechedparentchekbox;
        if (notcheckeparentdbox == 0) {
            jQuery(this).closest('.parent-checkbox-item').find('> .form-item input').prop('checked', 'checked');
        } else {
            jQuery(this).closest('.parent-checkbox-item').find('> .form-item input').prop('checked', '');
        }

        var $childparent = jQuery(this).closest('.child-checkbox-item');
        var totalsubcheckbox = jQuery(this).closest('.child-checkbox-item').find('input:not(.child)').length;
        var chechedsubchekbox = jQuery(this).closest('.child-checkbox-item').find('input:checked:not(.child)').length;
        var notcheckedcubbox = totalsubcheckbox - chechedsubchekbox;
        if (notcheckedcubbox == 0) {
            jQuery(this).closest('.child-checkbox-item').find('> .form-item input').prop('checked', 'checked');
        } else {
            jQuery(this).closest('.child-checkbox-item').find('> .form-item input').prop('checked', '');
        }
    });


    jQuery('.subchild-1-checkbox-item .form-item input').on('change', function () {
        var $parent = jQuery(this).closest('.parent-checkbox-item');
        var totalparentcheckbox = jQuery(this).closest('.parent-checkbox-item').find('input:not(.parent)').length;
        var chechedparentchekbox = jQuery(this).closest('.parent-checkbox-item').find('input:checked:not(.parent)').length;
        var notcheckeparentdbox = totalparentcheckbox - chechedparentchekbox;
        if (notcheckeparentdbox == 0) {
            jQuery(this).closest('.parent-checkbox-item').find('> .form-item input').prop('checked', 'checked');
        } else {
            jQuery(this).closest('.parent-checkbox-item').find('> .form-item input').prop('checked', '');
        }


        var $childparent = jQuery(this).closest('.child-checkbox-item');
        var totalchildcheckbox = jQuery(this).closest('.child-checkbox-item').find('input:not(.child)').length;
        var chechedchildchekbox = jQuery(this).closest('.child-checkbox-item').find('input:checked:not(.child)').length;
        var notcheckechilddbox = totalchildcheckbox - chechedchildchekbox;
        if (notcheckechilddbox == 0) {
            jQuery(this).closest('.child-checkbox-item').find('> .form-item input').prop('checked', 'checked');
        } else {
            jQuery(this).closest('.child-checkbox-item').find('> .form-item input').prop('checked', '');
        }

        var $subchildparent = jQuery(this).closest('.subchild-checkbox-item');
        var totalsubcheckbox = jQuery(this).closest('.subchild-checkbox-item').find('input:not(.sub-child)').length;
        var chechedsubchekbox = jQuery(this).closest('.subchild-checkbox-item').find('input:checked:not(.sub-child)').length;
        var notcheckesubdbox = totalsubcheckbox - chechedsubchekbox;
        if (notcheckesubdbox == 0) {
            $subchildparent.find('> .form-item input').prop('checked', 'checked');
        } else {
            $subchildparent.find('> .form-item input').prop('checked', '');
        }
    });
});
//custom multiselect nested checkbox js on ajax complete  end

jQuery(document).ready(function () {

    //jQuery('.fieldset .fieldset-title').on('click', function (event) {
    jQuery(document).on('click', '.fieldset .fieldset-title', function (event) {
        event.stopPropagation();
        if (jQuery(this).parent('.fieldset').hasClass('open')) {
            jQuery(this).parent('.fieldset').removeClass('open');
            jQuery(this).next('div').hide();
        } else {
            jQuery('.fieldset .fieldset-wrapper').hide();
            jQuery('.fieldset').removeClass('open');
            jQuery(this).parent('.fieldset').addClass('open');
            jQuery(this).next('div').show();
        }
    });

    // jQuery('.bam-lib-filter .fieldset .fieldset-title').on('click', function (event) {
    //     event.stopPropagation();
    //     if(jQuery(this).parent('.fieldset').hasClass('open')){
    //        jQuery(this).parent('.fieldset').removeClass('open');
    //         jQuery(this).next('div').hide();
    //     } 
    //     else{
    //         jQuery('.bam-lib-filter .fieldset .fieldset-wrapper').hide();
    //         jQuery('.bam-lib-filter .fieldset').removeClass('open');
    //         jQuery(this).parent('.fieldset').addClass('open');
    //         jQuery(this).next('div').show();
    //     }
    // });

    if (window.matchMedia('(max-width:767px)').matches) {
        if (jQuery('.signpost-listing__slider .signpost-listing__item').length > 0) {
            jQuery('.signpost-listing__slider .views-element-container').not('.slick-initialized').slick({
                infinite: true,
                arrows: false,
                dots: true,
                slidesToScroll: 1,
                slidesToShow: 1
            });
        }
    }

    jQuery(document).on('click', '.collapse-sub-child', function () {
        jQuery(this).parents('.subchild-checkbox-item').find('.subchild-1-checkbox-item').slideToggle();
    });
    jQuery(document).on('click', '.collapse-child', function () {
        jQuery(this).closest('.child-checkbox-item').find('.subchild-checkbox-item').slideToggle();
        //jQuery(this).closest('.subchild-checkbox-item').find('.subchild-1-checkbox-item').slideToggle();

        // if(window.matchMedia('(min-width:1025px)').matches){
        //     jQuery(".listing_page__wrapper .exposed-form .views-exposed-form .fieldset .form-checkboxes:not(.fieldgroup)").niceScroll('.fieldgroup',{
        //         cursoropacitymin:0.2,
        //         cursorcolor:'#0f3557',
        //         cursorborder:'none',
        //         cursorborderradius:4,
        //         cursoropacitymax: 0.3,
        //         horizrailenabled:false,
        //         cursorwidth:8,
        //         scrollspeed: 30,
        //         mousescrollstep: 20, 
        //     }).resize();
        // }

        // if(window.matchMedia('(min-width:1025px)').matches){
        //     jQuery(".bam-filter-form .fieldset .fieldset-wrapper [class^=col]").niceScroll('.form-checkboxes',{
        //         cursoropacitymin:0.2,
        //         cursorcolor:'#0f3557',
        //         cursorborder:'none',
        //         cursorborderradius:4,
        //         cursoropacitymax: 0.3,
        //         horizrailenabled:false,
        //         cursorwidth:8,
        //         scrollspeed: 30,
        //         mousescrollstep: 20, 
        //     }).resize();
        // }
    });

}); //Document Ready End

function setAllCheckboxLabel() {
    var allCheckboxDropdown = jQuery('.fieldset:not(.field-quicklink-icon-wrapper)');
    for (var i = 0; i < allCheckboxDropdown.length; i++) {
        setCurrentChekboxLabel(allCheckboxDropdown[i]);
    }
}

function setCurrentChekboxLabel(checboxElementParent) {
    var originaltext = jQuery(checboxElementParent).find('.fieldset-legend').text();
    var selecttext = jQuery(checboxElementParent).find('.fieldset-legend');
    var totalcheckedoptions = jQuery(checboxElementParent).find('input:checked');
    var totaloptions = jQuery(checboxElementParent).find('input').length;
    var Filtered = Drupal.t('Filtered');
    if ((totalcheckedoptions.length > 0) && (totalcheckedoptions.length < totaloptions)) {
        //selecttext.html(totalcheckedoptions.length+ ' Selected');
        selecttext.html(Filtered);
        jQuery('<span class="clearfilter"></span>').insertAfter(selecttext);
        jQuery(checboxElementParent).find('.fieldset-legend').after()
    } else if (totalcheckedoptions.length == totaloptions) {
        selecttext.html(Filtered);
        jQuery('<span class="clearfilter"></span>').insertAfter(selecttext);
    } else {
        selecttext.text(originaltext);
    }
}